module.exports = __webpack_public_path__ + "static/blog59-4274da89267c145e45099abde01aca8e.png";